<template>
    <div>
        <el-page-header @back="goBack" content="服务人员详情"></el-page-header>
        <Box style="margin-top: 20px;">
            <template #body>
                <table class="table">
                    <tbody>
                    <tr>
                        <td class="dockert_img_td" rowspan="6">
                            <el-image style="width: 100%;" :src="user_avatar"></el-image>
                        </td>
                        <td class="docker_title_td">服务人员姓名</td>
                        <td class="docker_value_td">{{ user_name }}</td>
                        <td class="docker_title_td">电话</td>
                        <td class="docker_value_td">{{ mobile }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">权限角色</td>
                        <td class="docker_value_td">{{ role_name }}</td>
                        <td class="docker_title_td">组长</td>
                        <td class="docker_value_td">{{ group_user_name }}（{{group_user_mobile}}）</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">所属公司</td>
                        <td class="docker_value_td">{{ company_name }}</td>
                        <td class="docker_title_td">所属部门</td>
                        <td class="docker_value_td">{{ department_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">所属运营组</td>
                        <td class="docker_value_td">{{ group_name }}</td>
                        <td class="docker_title_td">专长介绍</td>
                        <td class="docker_value_td">{{ introduction }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">负责特属服务对象人数</td>
                        <td class="docker_value_td">{{ user_count }}</td>
                        <td class="docker_title_td">职务</td>
                        <td class="docker_value_td">{{posistion}}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">负责特属专家人数</td>
                        <td class="docker_value_td">{{ doctor_count }}</td>
                        <td class="docker_title_td"></td>
                        <td class="docker_value_td"></td>
                    </tr>
                    </tbody>
                </table>
            </template>
        </Box>

        <div class="table_message_box">
            <p style="float: left">负责特属服务对象列表</p>
            <div class="search_data">
                <el-input @change="searchUser" v-model="search_user_data" placeholder="特属服务对象姓名模糊搜索"/>
            </div>
            <el-table ref="multipleTable" :data="userList" border style="width: 100%">
                <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="80" prop="no" label="序号" align="center" label-class-name="label" v-if="role_id != 1"></el-table-column>
                <el-table-column width="160" prop="user_name" label="特属服务对象姓名" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="bloc_name" label="所属集团" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="180" prop="mobile" label="手机号码" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="200" class-name="admin_user_name" prop="doctor_list" label="签约专家" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="140" prop="client_doctor_number" label="签约特属专家数" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="180" prop="client_doctor_number" label="签约特属专家数" align="center" label-class-name="label" v-if="role_id != 1"></el-table-column>
                <el-table-column width="150"  prop="client_doctor_effective_number" label="签约生效特属专家数" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="150" prop="client_doctor_expired_number" label="签约过期特属专家数" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="100" prop="user_assistant_number" label="联系人数量" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="140" prop="user_assistant_number" label="联系人数量" align="center" label-class-name="label" v-if="role_id != 1"></el-table-column>
                <el-table-column width="110" prop="expired_date" label="协议到期时间" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="150" prop="expired_date" label="协议到期时间" align="center" label-class-name="label" v-if="role_id != 1"></el-table-column>
                <el-table-column width="70" prop="status" label="状态" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="120" prop="status" label="状态" align="center" label-class-name="label" v-if="role_id != 1"></el-table-column>
                <el-table-column width="100" prop="address" label="操作" align="center" label-class-name="label" v-slot="scope" v-if="role_id == 1">
                    <el-button :id="'hospitalEdit'" @click="goUserDetail(scope.row)" type="text" size="small">
                        查看
                    </el-button>
                </el-table-column>
                <el-table-column width="140" prop="address" label="操作" align="center" label-class-name="label" v-slot="scope" v-if="role_id != 1">
                    <el-button :id="'hospitalEdit'" @click="goUserDetail(scope.row)" type="text" size="small">
                        查看
                    </el-button>
                </el-table-column>
            </el-table>
            <el-pagination class="mg-20 ta-r" background layout="total, sizes, prev, pager, next, jumper"
                           :page-sizes="[5,10, 25, 50, 100]" :total="user_total" :page-size="user_perpage"
                           :current-page="user_page" @prev-click="userChangePage" @next-click="userChangePage"
                           @current-change="userChangePage" @size-change="userChangeSite"></el-pagination>
        </div>

        <div class="table_message_box">
            <p style="float: left">负责特属专家列表</p>
            <div class="search_data">
                <el-input @change="searchDoctor" v-model="search_doctor_data" placeholder="特属专家姓名模糊搜索"/>
            </div>
            <el-table ref="multipleTable" :data="doctorList" border style="width: 100%">
                <el-table-column width="50px" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="150px" prop="user_name" label="特属专家姓名" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="165" prop="idcard" label="身份证号" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="110" prop="mobile" label="手机号码" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="120px" prop="doctor_title_name" label="职称" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="hospital_nick_name" label="单位" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="department_name" label="科室" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="110px" prop="expired_date" label="协议到期时间" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="80px" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="100px" prop="max_client" label="签约特属服务对象上限" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="170px" prop="max_client" label="签约特属服务对象上限" align="center" label-class-name="label" v-if="role_id != 1"></el-table-column>
                <el-table-column width="100px" prop="number" label="签约特属服务对象数" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="160px" prop="number" label="签约特属服务对象数" align="center" label-class-name="label" v-if="role_id != 1"></el-table-column>
                <el-table-column width="110"  prop="effective_number" label="签约生效特属服务对象数" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="110"  prop="expired_number" label="签约过期特属服务对象数" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>
                <el-table-column width="100px" prop="address" label="操作" align="center" label-class-name="label" v-slot="scope">
                    <el-button :id="'hospitalEdit'" @click="goDoctorDetail(scope.row)" type="text" size="small">
                        查看
                    </el-button>
                </el-table-column>
            </el-table>
            <el-pagination class="mg-20 ta-r" background layout="total, sizes, prev, pager, next, jumper"
                           :page-sizes="[5,10, 25, 50, 100]" :total="doctor_total" :page-size="doctor_perpage"
                           :current-page="doctor_page" @prev-click="doctorChangePage" @next-click="doctorChangePage"
                           @current-change="doctorChangePage" @size-change="doctorChangeSite"></el-pagination>
        </div>

    </div>
</template>
<script>
import env from "@/api/env";
import Box from "@/components/Box.vue";
import {
    check
} from "@/utils/checkData";
import {VueCropper} from "vue-cropper";
import {authUrlCheck, base64Parser, fileType, getBase64Image, loadFile} from "@/api/order";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import {saveAs} from "file-saver";
import ImageModule from "docxtemplater-image-module-free";
import pdf from 'vue-pdf'
import {getUserInfos} from "@/utils/userInfos";

export default {
    components: {
        Box,
    },
    data() {
        return {
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            role_id: 0,
            child_role_id: 0,
            id: '',
            user_name: '',
            user_avatar: '',
            mobile: '',
            role_name: '',
            group_user_name: '',
            group_user_mobile: '',
            company_name: '',
            department_name: '',
            group_name: '',
            introduction: '',
            posistion: '',
            user_count: '',
            doctor_count: '',
            manager_count: '',
            search_user_data: '',
            userList: [],
            user_total: 0,
            user_page: 1,
            user_perpage: 10,
            search_doctor_data: '',
            doctorList: [],
            doctor_total: 0,
            doctor_page: 1,
            doctor_perpage: 10,
            search_manager_data: '',
            managerList: [],
            manager_total: 0,
            manager_page: 1,
            manager_perpage: 10,

        };
    },
    created() {
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
            this.child_role_id = parseInt(userInfo.child_role_id)
        }
        this.id = this.$route.params.id || localStorage.getItem('operate_user_id');

        this.getDetail()
        this.getUserList()
        this.getDoctorList()
        // this.getManagerList()
    },
    mounted() {
    },
    methods: {
        getDetail() {

            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'operateUserDetail',
                params: {
                    id: this.id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.user_name = res.data.data.user_name;
                this.mobile = res.data.data.mobile;
                this.role_name = res.data.data.role_name;
                this.group_user_name = res.data.data.group_user_name;
                this.group_user_mobile = res.data.data.group_user_mobile;
                this.company_name = res.data.data.company_name;
                this.department_name = res.data.data.department_name;
                this.group_name = res.data.data.group_name;
                this.user_count = res.data.data.user_count;
                this.doctor_count = res.data.data.doctor_count;
                this.manager_count = res.data.data.manager_count;
                this.introduction = res.data.data.introduction;
                this.posistion = res.data.data.posistion;
                if (res.data.data.user_avatar) {
                    this.user_avatar = this.imgUrl + res.data.data.user_avatar;
                }
            });
        },
        // 返回上一页
        goBack() {
            if (this.$route.query.user_id) {
                window.close()
            } else {
                window.history.go(-1);
            }

        },

        getUserList() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'listing',
                pageinfo: {
                    page: this.user_page,
                    perpage: this.user_perpage,
                },
                params: {
                    user_name: this.search_user_data,
                    operate_user_id: this.id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 以序号代替ID
                    res.data.data.list[i].no = (this.user_page - 1) * this.user_perpage + i + 1
                    switch (res.data.data.list[i].status) {
                        case '1':
                            res.data.data.list[i].status = '启用';
                            res.data.data.list[i].status_number = '1';
                            break;
                        case '2':
                            res.data.data.list[i].status = '停用';
                            res.data.data.list[i].status_number = '2';
                            break;
                    }
                    switch (res.data.data.list[i].is_expired) {
                        case '1':
                            res.data.data.list[i].is_expired = '未缴纳';
                            break;
                        case '2':
                            res.data.data.list[i].is_expired = '已缴纳';
                            break;
                    }
                }
                this.userList = res.data.data.list;
                this.user_total = res.data.data.page.count;
            });
        },

        // 搜索预约信息
        searchUser() {
            this.user_page = 1;
            this.getUserList();
        },
        userChangePage(index) {
            this.user_page = index;
            this.getUserList();
        },

        userChangeSite(index) {
            this.user_perpage = index;
            this.getUserList();
        },
        goUserDetail(data) {
            localStorage.setItem('operate_user_id', this.id)
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/user/UserDetail', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({
                name: "userDetail",
                params: {user_id: data.user_id}
            });
        },
        getDoctorList() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'listing',
                pageinfo: {
                    page: this.doctor_page,
                    perpage: this.doctor_perpage,
                },
                params: {
                    user_name: this.search_doctor_data,
                    operate_user_id: this.id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 以序号代替ID
                    res.data.data.list[i].no = (this.doctor_page - 1) * this.doctor_perpage + i + 1

                    switch (res.data.data.list[i].status) {
                        case '1':
                            res.data.data.list[i].status = '启用';
                            res.data.data.list[i].status_number = '1';
                            break;
                        case '2':
                            res.data.data.list[i].status = '停用';
                            res.data.data.list[i].status_number = '2';
                            break;
                    }
                }
                this.doctorList = res.data.data.list;
                this.doctor_total = res.data.data.page.count;
            });
        },

        // 搜索预约信息
        searchDoctor() {
            this.doctor_page = 1;
            this.getDoctorList();
        },
        doctorChangePage(index) {
            this.doctor_page = index;
            this.getDoctorList();
        },

        doctorChangeSite(index) {
            this.doctor_perpage = index;
            this.getDoctorList();
        },

        goDoctorDetail(data) {
            localStorage.setItem('operate_user_id', this.id)
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/doctor/DoctorDetail', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({
                name: "doctorDetail",
                params: {user_id: data.user_id}
            });
        },

        getManagerList() {
            let params = {
                servername: 'Ruyi_AssistantAdminServices',
                method: 'assistantList',
                pageinfo: {
                    page: this.manager_page,
                    perpage: this.manager_perpage,
                },
                params: {
                    user_name: this.search_manager_data,
                    operate_user_id: this.id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 序号
                    res.data.data.list[i].no = (this.manager_page - 1) * this.manager_perpage + i + 1
                    switch (res.data.data.list[i].status) {
                        case '1':
                            res.data.data.list[i].status = '启用';
                            res.data.data.list[i].status_number = 1;
                            break;
                        case '2':
                            res.data.data.list[i].status = '停用';
                            res.data.data.list[i].status_number = 2;
                            break;
                    }
                }
                this.managerList = res.data.data.list;
                this.manager_total = res.data.data.page.count;
            });
        },

        // 搜索预约信息
        searchManager() {
            this.manager_page = 1;
            this.getManagerList();
        },
        managerChangePage(index) {
            this.manager_page = index;
            this.getManagerList();
        },

        managerChangeSite(index) {
            this.manager_perpage = index;
            this.getManagerList();
        },
        goManagerDetail(data) {
            localStorage.setItem('operate_user_id', this.id)
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/manager/managerDetail', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({
                name: "managerDetail",
                params: {user_id: data.user_id}
            });
        },

    },
};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.cropper-content {
    .cropper {
        width: auto;
        height: 300px;
    }
}

.avatar-btn, .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-btn {
    display: inline-block;
    text-align: center;
}

.avatar-btn, .avatar-uploader .el-upload:hover {
    border-color: #d9d9d9;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar-btn {
    width: 200px;
    height: 200px;
}


.docker-detail-header {
    text-align: right;
    margin: 20px 0 20px 0;

    .el-button {
        height: 32px;
        line-height: 6px;
    }
}

.table .dockert_img_td {
    width: 22% !important;
    padding: 10px;
    text-align: center;
}

.table .docker_title_td {
    width: 10% !important;
    padding-right: 10px;
    text-align: right;
    background-color: #f9fafd;
}

.table .docker_value_td {
    width: 28% !important;
}

.message_box .message_title {
    text-align: left;
    font-size: 16px;
}

.message_box table {
    border-collapse: collapse !important;
    color: #606266;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
}

.message_box table tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
}

.message_box table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}

.message_box table tr:nth-child(1) {
    background-color: #f9fafd;
}

.message_box table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}

.message_box table tr > td:first-of-type {
    border-left: 0;
    border-bottom: 0;
}

.message_box table tr td {
    border-left: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
    font-size: 14px;
    padding: 15px 0 15px 10px;
    width: auto !important;
    text-align: center;
}

.table_message_box {
    margin: 50px 0px 20px 0px;
}

.search_data {
    float: right;
    margin: 15px 0px 15px 0px;
    width: 20%;
}

.image_box {
    height: 500px;
    overflow: hidden;
    overflow-y: auto;

    image {
        width: 100%;
    }
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}

.doctor_search {
    text-align: left;
    width: 100%;
}
.table .dockert_img_td {
    width: 5% !important;
    padding: 10px;
    text-align: center;
    .el-image__inner{
        width: 140px;
    }
}
.el-table .admin_user_name .cell {
    white-space: pre-wrap;
}
</style>
